import { pushLiensMock, triptyqueStickersMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [triptyqueStickersMock(1), triptyqueStickersMock(2), triptyqueStickersMock(3), pushLiensMock];

export const franchiseChiffresMock: SlugPage = {
  ...pageBase({
    title: 'Franchise Chiffres',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-b2b-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
